
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SpmHelpIcon',

  props: {
    /**
     * Help text shown in the tooltip
     */
    text: {
      type: String,
      required: true,
    },
  },
});
